class NavigationUtil {
  static getTenant(): string {
    return window.location.pathname.split('/')[1];
  }

  static parseUrlParams(query: string) {
    const searchParams = query.split('&');
    const params: Record<string, string | null> = {};
    for (const searchParam of searchParams) {
      if (searchParam.trim()) {
        const [key, value] = searchParam.split('=');
        if (key) {
          const decodedKey = decodeURIComponent(key);
          params[decodedKey] = value ? decodeURIComponent(value) : null;
        }
      }
    }
    return params;
  }
}

export default NavigationUtil;
